import $ from 'jquery'
const jQuery = $;

(function ($) {

    $.fn.cityselect = function (options) {

        $.fn.cityselect.defaults = {
            triggleEle: '.J-city',
            targetEle: '.J-city-list',
            activeClass: 'city-active',
            hideClass: 'Hide'
        };

        return this.each(function () {

            let opts = $.extend({}, $.fn.cityselect.defaults, options),
                container = $(this),
                trigger = container.find(opts.triggleEle),
                target = container.find(opts.targetEle);

            function show() {

                trigger.addClass(opts.activeClass);
                target.removeClass(opts.hideClass);

                let pos = trigger.offset(),
                    topBorderWidth = parseInt(target.css('border-top-width'));

                target.css({
                    left: pos.left,
                    top: pos.top + trigger.outerHeight() - topBorderWidth
                });

            }

            function hide() {

                trigger.removeClass(opts.activeClass);
                target.addClass(opts.hideClass);

            }

            trigger.on('click', function (e) {

                if (!trigger.hasClass(opts.activeClass)) {

                    show();

                } else {

                    hide();

                }
                $('.dp-search-suggest').addClass('Hide')
                e.stopPropagation();

            });

            target.on('click', function (e) {

                e.stopPropagation();

            });
            [trigger, target].forEach((item) => { 
                item.on('mouseleave', () => {
                    hide();
                })
            })
            target.on('mouseenter', function () {

                show();

            });
            $(document).on('click', function () {

                hide();

            });

        });

    };

})(jQuery);



// WEBPACK FOOTER //
// ./modules/logo-input/js/city-select.js